import { CALL_API } from '../middleware/api'

export const STATIC_CONTENT_REQUEST = 'STATIC_CONTENT_REQUEST'
export const STATIC_CONTENT_SUCCESS = 'STATIC_CONTENT_SUCCESS'
export const STATIC_CONTENT_FAILURE = 'STATIC_CONTENT_FAILURE'

export const BACKGROUNDS_REQUEST = 'BACKGROUNDS_REQUEST'
export const BACKGROUNDS_SUCCESS = 'BACKGROUNDS_SUCCESS'
export const BACKGROUNDS_FAILURE = 'BACKGROUNDS_FAILURE'

export const NAMES_REQUEST = 'NAMES_REQUEST'
export const NAMES_SUCCESS = 'NAMES_SUCCESS'
export const NAMES_FAILURE = 'NAMES_FAILURE'

export const TEXTS_REQUEST = 'TEXTS_REQUEST'
export const TEXTS_SUCCESS = 'TEXTS_SUCCESS'
export const TEXTS_FAILURE = 'TEXTS_FAILURE'

export const TEXT_REQUEST = 'TEXT_REQUEST'
export const TEXT_SUCCESS = 'TEXT_SUCCESS'
export const TEXT_FAILURE = 'TEXT_FAILURE'

export function getStaticContent() {
  return {
    [CALL_API]: {
      endpoint: 'postcards/static',
      types: [
        STATIC_CONTENT_REQUEST,
        STATIC_CONTENT_SUCCESS,
        STATIC_CONTENT_FAILURE
      ],
      config: { method: 'GET' }
    }
  }
}

export function getBackgrounds() {
  return {
    [CALL_API]: {
      endpoint: 'postcards/backgrounds',
      types: [
        BACKGROUNDS_REQUEST,
        BACKGROUNDS_SUCCESS,
        BACKGROUNDS_FAILURE
      ],
      config: { method: 'GET' }
    }
  }
}

export function getNames(gender) {
  return {
    [CALL_API]: {
      endpoint: `postcards/names/${gender}`,
      types: [
        NAMES_REQUEST,
        NAMES_SUCCESS,
        NAMES_FAILURE
      ],
      config: { method: 'GET' }
    }
  }
}

export function getTexts(type) {
  return {
    [CALL_API]: {
      endpoint: `postcards/texts/${type}`,
      types: [
        TEXTS_REQUEST,
        TEXTS_SUCCESS,
        TEXTS_FAILURE
      ],
      config: { method: 'GET' }
    }
  }
}

export function getText(id) {
  return {
    [CALL_API]: {
      endpoint: `postcards/text/${id}`,
      types: [
        TEXT_REQUEST,
        TEXT_SUCCESS,
        TEXT_FAILURE
      ],
      config: { method: 'GET' }
    }
  }
}


// WEBPACK FOOTER //
// ./src/actions/ContentActions.js